<template>
  <div class="contrast" :style="{'margin-top': is_share ? '0' : '.3rem' }">
    <p class="title" v-if="cItem.hide_title == 0 && !is_share"><img :src="static_img_url + 'mobile/pic/tct_icon.png'" />{{cItem.title}}</p>
    <div class="contrast-summary" v-html="cItem.summary" v-if="!is_share"></div>
    <div class="contrast-nav" v-if="!is_share">
      <div v-for="item, index in cItem.content.x" :key="index"><div class="icon"></div>{{item.short_name}}</div>
    </div>
    <div style="position: relative; overflow: hidden; min-height: 1.2rem">
      <div style="width: 0; height: 0; overflow: hidden;">
        <div class="contrast-content" :id="'shareImg' + cItem.id" v-show="!imgbase">
          <div class="contrast-head">
            <div class="head-1" v-if="cItem.time_show_type == 0">领域/年</div>
            <div class="head-1" v-if="cItem.time_show_type == 1">领域/季度</div>
            <div class="head-1" v-if="cItem.time_show_type == 2">领域/月</div>
            <div class="head-2">
              <div
                class="head-item"
                v-for="year_item,year_index in years_axis"
                :key="year_index"
              >
                <span>{{year_item | tct_time_list(cItem.time_show_type)}}</span>
              </div>
            </div>
          </div>
          <div class="contrast-list">
            <div class="contrast-li" v-for="item in cItem.content.y" :key="item">
              <div class="label-tag">{{item | dealNeed(entityNtag)}}</div>
              <div class="label-data">
                <div
                  class="year-item"
                  v-for="year_item,year_index in years_axis"
                  v-if="year_index < years_axis.length"
                  :key="year_index"
                >
                  <div>
                    <div
                      class="data-item"
                      v-for="item2,index in cItem.content.x"
                      :key="index2"
                    >
                      <span
                        v-for="item3 in cItem.content.res"
                        v-if="item3.tag_id == item && item3.entity_id == item2.id && time_bollen(item3, year_item)"
                        :style="{'width': item_width(item3.ca_num)}"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img :src="imgbase" :preview="cItem.id" v-show="imgbase" class="imgbase"/>
      <div class="loading_img" v-if="!imgbase">
        <div class="con"><span class="loader-box"></span><br><p>图片生成中</p></div>
      </div>
    </div>
    <div class="share-area" v-if="!is_share">
      <p>数据来源：{{cItem.src_name | empty('动脉橙产业智库')}}</p>
      <div class="right">
        <span>分享至</span>
        <div @click="handleClickShare">
          <i class="iconfont">&#xe641;</i>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import html2canvas from 'html2canvas'
export default {
  props: ['uid', 'cItem', 'entityNtag'],
  data() {
    return {
      imgbase: '',
      max_num: 0,
      min_num: 0
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
    years_axis() {
      let arr = [],
          start_year = this.cItem.start_time ? moment(this.cItem.start_time).year() : 2010,
          end_year = this.cItem.end_time ? moment(this.cItem.end_time).year() : moment().year(),
          start_quarter = this.cItem.start_time ? moment(this.cItem.start_time).quarter() : 1,
          end_quarter = this.cItem.end_time ? moment(this.cItem.end_time).quarter() : moment().quarter(),
          start_month = this.cItem.start_time ? moment(this.cItem.start_time).month() + 1 : 1,
          end_month = this.cItem.end_time ? moment(this.cItem.end_time).month() + 1 : moment().month() + 1
      for (var i = start_year; i <= end_year; i++) {
        if (this.cItem.time_show_type == 0) {
          arr.push(i)
        } else if (this.cItem.time_show_type == 1){
          if (i == start_year && i != end_year) {
            for (var j = start_quarter; j <= 4; j++) {
              arr.push(i+'Q'+j)
            }
          } else if (i == end_year && i != start_year) {
            for (var j = 1; j <= end_quarter; j++) {
              arr.push(i+'Q'+j)
            }
          } else if (i == start_year && i == end_year) {
            for (var j = start_quarter; j <= end_quarter; j++) {
              arr.push(i+'Q'+j)
            }
          } else {
            for (var j = 1; j <= 4; j++) {
              arr.push(i+'Q'+j)
            }
          }
        } else if (this.cItem.time_show_type == 2){
          if (i == start_year && i != end_year) {
            for (var j = start_month; j <= 12; j++) {
              arr.push(i+'.'+j)
            }
          } else if (i == end_year && i != start_year) {
            for (var j = 1; j <= end_month; j++) {
              arr.push(i+'.'+j)
            }
          } else if (i == start_year && i == end_year) {
            for (var j = start_month; j <= end_month; j++) {
              arr.push(i+'.'+j)
            }
          } else {
            for (var j = 1; j <= 12; j++) {
              arr.push(i+'.'+j)
            }
          }
        }
      }
      return arr
    },
    time_bollen() {
      return function(item, t) {
        if (this.cItem.time_show_type == 0) {
          return item.year == t
        } else if (this.cItem.time_show_type == 1) {
          return item.year == t.split('Q')[0] && item.quarter == t.split('Q')[1]
        } else if (this.cItem.time_show_type == 2) {
          return item.year == t.split('.')[0] && item.month == t.split('.')[1]
        }
      }
    },
    item_width() {
      return function(n) {
        let l = this.max_num - this.min_num
        let m = n - this.min_num
        return m > 0 ? 10 + 20*(m/l) + 'px' : '10px'
      }
    },
    getLoading() {
      return this.loading1 && this.loading2
    },
    is_share() {
      return this.$route.name == 'MShareScatter' || this.$route.name == 'MShareScatterWx'
    }
  },
  methods: {
    handleClickShare() {
      this.$router.push({name: 'MShareScatter', query: { tct_id: this.cItem.id,  theme_uid: this.uid}})
    }
  },
  created() {
    this.max_num = this.min_num = this.cItem.content.res[0] ? Number(this.cItem.content.res[0].ca_num) : 0
    this.cItem.content.res.map((a) => {
      this.max_num = Number(a.ca_num) > this.max_num ? Number(a.ca_num) : this.max_num
      this.min_num = Number(a.ca_num) > this.min_num ? this.min_num : Number(a.ca_num)
    })
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        html2canvas(document.getElementById('shareImg'+this.cItem.id),{ scale: 2}).then((canvas) => {
          let save_url= canvas.toDataURL("image/png")
          this.$set(this.$data, 'imgbase', save_url)
          if(this.is_share) {
            this.$emit('greatImg', true)
          }
          this.$previewRefresh()
        })
      }, 200)
    })
  }
}
</script>
<style lang="stylus" scoped>
@import '~mobile/styles/constrast.stylus'
@import '~mobile/styles/shareLoading.stylus'
.contrast
  &-nav
    > div
      &:nth-of-type(1)
        .icon
          background-color: #9254DE
      &:nth-of-type(2)
        .icon
          background-color: #40A9FF
      &:nth-of-type(3)
        .icon
          background-color: #1EA69B
      &:nth-of-type(4)
        .icon
          background-color: #FFCB6A
      &:nth-of-type(5)
        .icon
          background-color: #E96350
  &-li .label-data .year-item .data-item
    &:nth-of-type(1)
      span
        background-color: #9254DE
    &:nth-of-type(2)
      span
        background-color: #40A9FF
    &:nth-of-type(3)
      span
        background-color: #1EA69B
    &:nth-of-type(4)
      span
        background-color: #FFCB6A
    &:nth-of-type(5)
      span
        background-color: #E96350
</style>
